import type { DocPageContent } from '../docs-content'

const page = {
  order: 23,
  slug: 'reference',
  title: '参考',
  description: '支持的格式，以及本指南中所用术语的词汇表。',
  category: '参考',
  related: ['concepts', 'keyboard-shortcuts'],
  sections: [
    {
      title: '格式',
      blocks: [
        {
          kind: 'table',
          headers: ['用途', '类型'],
          rows: [
            ['导入', '视频、音频、图像、GIF、SVG、生成的素材、复合片段'],
            ['视频导出', 'MP4、MOV、WebM、MKV'],
            ['音频导出', 'MP3、AAC、WAV'],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '编解码器的支持取决于你的浏览器能够解码和编码的能力。',
        },
      ],
    },
    {
      title: '剪辑术语',
      blocks: [
        {
          kind: 'table',
          headers: ['术语', '含义'],
          rows: [
            ['入/出范围', '用于源编辑与导出范围的标记起点与终点。'],
            ['源余量', '片段边缘之外的空闲帧，修剪与转场所需。'],
            ['波纹编辑', '一种会推移后续素材、以腾出或闭合时间轴空间的编辑。'],
            ['滚动编辑', '一种在两个相邻片段之间移动切口的编辑。'],
            ['滑移编辑', '在不移动片段的情况下改变其内部的源帧。'],
            ['滑动编辑', '移动片段的同时调整其相邻的切口。'],
          ],
        },
      ],
    },
    {
      title: '功能术语',
      blocks: [
        {
          kind: 'table',
          headers: ['术语', '含义'],
          rows: [
            ['工作区', '精剪读取与写入的文件夹。'],
            ['代理', '为重媒体生成的轻量副本，用于更流畅的播放。'],
            ['复合片段', '时间轴中一段被编组为单个可复用媒体项的片段。'],
            ['调整图层', '其特效与调色作用于其下方片段的图层。'],
            ['关键帧', '在特定时间为某个属性设置的数值，用于制作动画。'],
            ['LUT', '应用色彩转换的查找表（.cube）。'],
            ['目标轨道', '源监视器编辑所发送到的目标时间轴轨道。'],
            ['渲染队列', '按顺序排列、逐个渲染的导出任务列表。'],
            ['起飞前检查', '导出开始前运行的就绪性检查。'],
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
